import { useState } from "react";
import { useEffect } from "react";

import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import { Box, Grid, Tooltip, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { v4 as uuid } from "uuid";

import OmniAssessmentValueTextFab from "../ui/omniAssessmentValueTextFab";
import OmniTextField from "../ui/omniTextField";

const getAnswerTextAsHTML = text => {
  return { __html: `${text}` };
};

const QuestionWeightDisplay = props => {
  const { question, onAnswerSelected, startNextTimer } = props;

  const theme = useTheme();

  const defaultDelay = 350;

  const [validAnswerSelected, setValidAnswerSelected] = useState(question.answerValue != null);

  const [unsure, setUnsure] = useState(false);
  const [error, setError] = useState(false);

  const [weight, setWeight] = useState("");

  useEffect(() => {
    if (question.answerValue == null) {
      setError(true);
      setUnsure(false);
    } else if (question.answerValue && question.answerValue[0] === "unsure") {
      setError(false);
      setUnsure(true);
    } else {
      setError(false);
      setUnsure(false);
      setWeight(parseInt(question.answerValue[0]));
    }
  }, [question]);

  useEffect(() => {
    if (weight != null && (weight < 50 || weight >= 1000)) {
      setUnsure(false);
      setError(true);
      onAnswerSelected(null);
      setValidAnswerSelected(false);
    } else {
      setError(false);
      onAnswerSelected([weight]);
      setValidAnswerSelected(true);
    }
  }, [weight, setUnsure, setError, onAnswerSelected]);

  return (
    <Grid id="container" container item direction="row" spacing={2} justifyContent="center">
      <Grid id="weightField" xs={12} item padding={1} justifyContent="center">
        <Box
          sx={{ justifyContent: "center", display: "flex", width: "100%", flexDirection: "row" }}
        >
          <OmniTextField
            sx={{ width: "135px" }}
            key={`answerOptionQuestion${question.omniID}W`}
            name={uuid()}
            value={weight}
            type="number"
            showNumberControls={false}
            error={error}
            onFocus={event => event.target.select()}
            label={"Weight (lbs)"}
            onChange={event => {
              let onlyNums = event.target.value.toString();
              onlyNums = onlyNums.replace(/[^0-9]/g, "");
              onlyNums = onlyNums.slice(0, 3);
              setWeight(onlyNums);
            }}
            onKeyPress={e => {
              if (e.key === "Enter" && validAnswerSelected) {
                startNextTimer(defaultDelay);
              }
            }}
            autoFocus
          />
        </Box>
      </Grid>
      <Grid id="unsureButton" item xs={11} sx={{ marginTop: theme.spacing(2) }}>
        <Grid
          id={`questionGrid1`}
          container
          item
          xs={11}
          justifyContent="center"
          spacing={2}
          sx={{ marginLeft: "4px" }}
        >
          <Tooltip title={question.answerOptions[0].helpText || ""} placement="left">
            <>
              <OmniAssessmentValueTextFab
                key={`answerOption${uuid()}`}
                color="primary"
                size="large"
                variant={"outlined"}
                onClick={e => {
                  e.stopPropagation();
                  setUnsure(true);
                  onAnswerSelected(["unsure"]);
                  startNextTimer(defaultDelay);
                }}
                sx={{ width: "100%", "&:hover": { color: theme.palette.primary.contrastText } }}
              >
                <Grid
                  container
                  justifyContent="center"
                  direction="row"
                  sx={{ width: "100%", alignItems: "center" }}
                >
                  <Grid item justifySelf="center" xs>
                    <Typography
                      variant="button"
                      dangerouslySetInnerHTML={getAnswerTextAsHTML("I don't know")}
                    />
                  </Grid>
                  {unsure && (
                    <CheckCircleRoundedIcon
                      sx={{
                        position: "absolute",
                        top: 8,
                        right: 16,
                        maxWidth: "32px",
                        maxHeight: "32px",
                        alignSelf: "baseline",
                      }}
                    />
                  )}
                </Grid>
              </OmniAssessmentValueTextFab>
            </>
          </Tooltip>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default QuestionWeightDisplay;
